module.exports = __webpack_public_path__ + "img/trello.732cf32a.svg";